/* Hey Hottie - the third-item nudge in the cart.
 *
 * Liquid renders the whole pool of candidates once, hidden. This decides,
 * on every cart change, which state to show and which three candidates are
 * worth showing - the ones they do not already have.
 *
 * The discount itself is AUTOMATIC in Shopify - there is no code to apply.
 * So this only ever has one job: tell someone sitting on two items that a
 * third one is half price, and let them add it without leaving the cart.
 * Shopify does the rest by itself, which is why there is no "apply" button
 * here. A button that applies an automatic discount is a button that lies.
 */
(function () {
  'use strict';

  var WANT = 3;           /* three in the cart is what qualifies */
  var SHOW = 3;           /* how many candidates to offer */

  function root() {
    return ((window.Shopify && window.Shopify.routes) || {}).root || '/';
  }

  /* Any discount at all means the cart is already saving money and we have
     no business nagging. Being wrong in this direction is free; being wrong
     the other way is a box that says "your discount is missing" to someone
     who already has it. */
  function alreadySaving(cart) {
    if (cart.total_discount > 0) return true;
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length) return true;
    for (var i = 0; i < cart.items.length; i++) {
      var allocs = cart.items[i].line_level_discount_allocations || [];
      if (allocs.length) return true;
    }
    return false;
  }

  function inCart(cart, id) {
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(id)) return true;
    }
    return false;
  }

  function shipBars() {
    return document.querySelectorAll('[data-hh-ship]');
  }

  function paint(cart) {
    var boxes = document.querySelectorAll('[data-hh-nudge]');
    if (!boxes.length) return;

    var count = cart.item_count || 0;
    var saving = alreadySaving(cart);

    /* Only one thing to say, and only at one moment: they have two, and a
       third is half off. At three Shopify has already applied it. */
    var state = 'off';
    if (count === WANT - 1 && !saving) state = 'offer';

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var line = box.querySelector('[data-hh-nudge-line]');
      var picks = box.querySelector('[data-hh-nudge-picks]');
      var err = box.querySelector('[data-hh-nudge-err]');

      if (err) err.hidden = true;

      if (state === 'off') {
        box.hidden = true;
        continue;
      }

      box.hidden = false;

      if (line) {
        line.textContent = 'add one more - buy 2, get 1 50% off.';
      }

      /* Offer things they have not already got. Showing someone the item
         already sitting in their cart is how a nudge reads as a robot. */
      var all = box.querySelectorAll('[data-hh-nudge-pick]');
      var shown = 0;
      for (var j = 0; j < all.length; j++) {
        var id = all[j].getAttribute('data-hh-nudge-pick');
        var ok = shown < SHOW && !inCart(cart, id);
        all[j].hidden = !ok;
        if (ok) shown++;
      }
      if (picks) picks.hidden = shown === 0;
      if (shown === 0) box.hidden = true;
    }

    /* One message at a time: while this is speaking, the shipping bar is not.
       Adding a third item usually clears the shipping threshold anyway, so
       the two would be saying the same thing in different words. */
    var bars = shipBars();
    for (var k = 0; k < bars.length; k++) {
      bars[k].classList.toggle('hh-ship--yield', state !== 'off');
    }
  }

  function refresh() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart); return cart; })
      .catch(function () { /* leave whatever is on screen */ });
  }

  document.addEventListener('click', function (e) {
    var pick = e.target.closest && e.target.closest('[data-hh-nudge-pick]');
    if (!pick || pick.disabled) return;

    var box = pick.closest('[data-hh-nudge]');
    if (!box) return;

    pick.disabled = true;
    pick.classList.add('hh-nudge__pick--busy');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: pick.getAttribute('data-hh-nudge-pick'), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (d) {
          if (!res.ok) throw new Error(d.description || d.message || 'no');
          return d;
        });
      })
      .then(function () {
        /* No navigation. The discount is automatic, so by the time the cart
           repaints the saving is already on it - they watch it happen
           instead of being sent somewhere to be told about it.
           hh-cartwatch.js turns this add into the repaint. */
      })
      .catch(function (e2) {
        pick.disabled = false;
        pick.classList.remove('hh-nudge__pick--busy');
        var err = box.querySelector('[data-hh-nudge-err]');
        if (err) {
          err.textContent = "couldn't add that one just now.";
          err.hidden = false;
        }
        console.warn('[hey hottie] nudge add failed:', e2);
      });
  });

  function boot() {
    var events = [
      'cart:updated',
      'cart:item-added',
      'quick-cart:updated',
      'quick-cart:open',
      'hh:cart-changed'
    ];
    for (var i = 0; i < events.length; i++) {
      document.addEventListener(events[i], function () { refresh(); });
    }
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
